import { GlobalAxios } from "../axios/axios-config";
import { ITicketAutomationMacro } from "../models/ticket-automation-macro";
const TICKET_AUTOMATION_MACRO_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutomationMacro/";

export const listTicketAutomationMacros = (params?: any) => {
  return GlobalAxios.get<ITicketAutomationMacro[]>(
    TICKET_AUTOMATION_MACRO_ROUTE + "list",
    {
      params: params,
    }
  );
};
